<template>
  <div class="events" v-if="tournamentEvents.length">
    <section class="is-flex is-align-items-stretch">
      <div
        v-for="e in tournamentEvents.slice(0, 3)"
        :key="e.tournamentId"
        class="eventCard"
      >
        <p class="title is-4 is-spaced has-text-info-dark">{{ e.name }}</p>
        <p class="subtitle is-5 is-spaced mb-2">
          {{ e.startTime | asDayjsFormat("dddd, DD MMM YYYY") }}
        </p>
        <p class="title is-5 mb-4">
          {{ e.startTime | asTime }} - {{ e.finishTime | asTime }}
        </p>
        <a
          v-if="!e.hasRegistered"
          class="button is-danger"
          :href="
            e.productId
              ? `subscribe/?plan=${e.productId.trim()}`
              : '' | chessquadPage
          "
          :disabled="
            !e.productId ||
            (e.playerLimit > 0 && e.playerCount >= e.playerLimit)
          "
        >
          Register
        </a>
        <router-link
          v-else-if="e.hasJoined"
          class="button is-info"
          :to="`/tournaments/${e.tournamentId}`"
        >
          Joined
        </router-link>
      </div>
    </section>
    <h4 class="subtitle is-6">Trophies and book prizes for top scorers!</h4>
  </div>
</template>

<script>
import { firestore } from "@/services/firebase";
import { hasPlayer } from "@shared/tournament/helper";
import { ONLINE_STATUS } from "../../constants";

export default {
  name: "TournamentRegister",

  props: ["subscriptions", "tournaments", "player"],

  data() {
    return {
      events: [
        {
          tournamentId: "gS3FPb4jyhgbmwtKNte6",
          title: "Beginner/Rookie",
          time: "9:30am - 12:30pm",
          productId: "prod_JuZJHx4KodWErJ",
          // disabled: true,
        },
        {
          tournamentId: "6nfOAFAcBwlHpAQ3ciNG",
          title: "Intermediate/Advanced",
          time: "2pm - 5pm",
          productId: "prod_JuZOCw9JLg8AYq",
        },
      ],
    };
  },

  computed: {
    tournamentEvents() {
      return this.tournaments
        .filter((t) => t.privacy === "Paid")
        .map((t) => {
          return {
            ...t,
            tournamentId: t.id,
            hasRegistered: this.hasRegistered(t),
          };
        });
    },

    registeredButNotJoinedEvents() {
      if (!this.player) return null;
      return this.tournamentEvents.filter(
        (e) => e.hasRegistered && e.hasJoined === false
      );
    },

    myPlanIds() {
      return this.subscriptions
        .filter((s) => s.status === ONLINE_STATUS.ACTIVE)
        .map((s) => s.plan_id);
    },
  },

  watch: {
    tournaments: {
      immediate: true,
      handler() {
        this.updateJoinedStatuses();
      },
    },

    // registeredButNotJoinedEvents: {
    //   immediate: true,
    //   handler() {
    //     if (!this.registeredButNotJoinedEvents) return;
    //     // Autojoin player to tournament
    //     this.registeredButNotJoinedEvents.forEach((event) => {
    //       TournamentHelper.addPlayer(this.player, event.tournament).then(
    //         this.updateJoinedStatus(event.tournament)
    //       );
    //     });
    //   },
    // },
  },

  filters: {
    chessquadPage(page) {
      if (!page) return null;
      return `//www.chesssquad.com/${page}`;
    },
  },

  methods: {
    hasRegistered(tournament) {
      return (
        tournament.planIds &&
        tournament.planIds.filter((planId) =>
          this.myPlanIds.includes(planId.trim())
        ).length
      );
    },

    updateJoinedStatuses() {
      if (!this.tournaments || !this.tournaments.length) return;
      this.tournaments.forEach((tournament) => {
        this.updateJoinedStatus(tournament);
      });
    },

    updateJoinedStatus(tournament) {
      if (!this.player) return false;
      hasPlayer(firestore, tournament, this.player).then((joined) => {
        const event = this.events.find((e) => e.tournamentId === tournament.id);
        if (event) event.hasJoined = joined;
        this.events = [...this.events];
      });
    },
  },
};
</script>

<style scoped>
.events {
  text-align: center;
  background-color: lightskyblue;
  padding: 1rem;
  /* border-radius: 1rem; */
}

.eventCard {
  /* font-size: 1.2em; */
  text-align: center;
  border: 3px solid #5ea3ce;
  padding: 1rem;
  flex-basis: 0;
  flex-grow: 1;
}
</style>
